import { MultipleDealLostModalProps } from './MultipleDealLostModal';
import { openModal } from '@core/components/ModalStack';
import { Subject } from 'rxjs';

export function openMultipleDealLostModal(props: Omit<MultipleDealLostModalProps, 'onDone'>) {
  const obs$ = new Subject<boolean>();
  import('./MultipleDealLostModal').then(module =>
    openModal(module.MultipleDealLostModal, {
      ...props,
      onDone: result => {
        obs$.next(result);
        obs$.complete();
      },
    }),
  );
  return obs$;
}
